<template>
  <div>
    <page-header :actions="pageActions" :page="page" />
    <validation-observer ref="csseFormValidator">
      <div v-if="!inEditMode && canShowCSEEOfficialQuestion" class="mb-3">
        <ordered-header-card class="manage-specialist" :is-ordered="false">
          <div slot="content">
            <div class="row mb-2">
              <div class="col-12 mb-2">
                <div class="row">
                  <div class="col-12 custom-control-inline">
                    <label class="mr-2">
                      ¿Está añadiendo un funcionario de CSEE para la
                      coordinación de citas en localidades servicio al cliente?
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div slot="actions">
            <validation-provider
              v-slot="{ errors }"
              name="CSSEOfficial"
              rules="required"
            >
              <custom-radio
                id="rbtn-CSSEOfficial"
                v-model="selectedCSEEOfficialAnswer"
                :change-event="onChangeCSSEEOfficialAnswer"
                class="manage-specialist__custom-radio"
                :custom-error-msg="'Debe seleccionar una opción'"
                :custom-style="{
                  separator: '0px',
                  radioButtonWidth: '85px',
                  centerBorderRadius: true,
                }"
                :error="errors[0]"
                is-question-list
                name="CSSEOfficialQuestions"
                :options="csseOfficialOptions"
                type="questions"
              />
            </validation-provider>
          </div>
        </ordered-header-card>
      </div>
    </validation-observer>

    <ssn-search
      v-if="
        !inEditMode &&
          (selectedCSEEOfficialAnswer == null || !isCreatingCSEEOficial)
      "
      :csse-form-validator="this.csseFormValidator()"
      @on-create="setActions"
      @on-specialist-added="specialistAdded"
      @on-specialist-found="specialistFound"
    />

    <user-search
      v-if="!inEditMode && isCreatingCSEEOficial"
      :csse-form-validator="this.csseFormValidator()"
      @on-create="setActions"
      @on-specialist-added="specialistAdded"
      @on-specialist-found="specialistFound"
    />

    <board v-if="inEditMode" class="mb-4" :details="board" />
    <b-tabs
      v-if="inEditMode"
      content-class="mt-3"
      nav-class="mipe-orange-tabs"
      no-nav-style
    >
      <b-tab active title="Información de Especialista">
        <specialist
          ref="specTab"
          v-model="specialistData"
          :disabled="isReadOnly"
          :exemption-files="exemptionFiles"
          :immediate-save="inImmediateSaveMode"
          :is-exemption-param-enabled="isExemptionParamEnabled"
          :is-exemption-required="isExemptionRequired"
          @on-specialist-change="specialistChange"
          @on-specialist-created="specialistCreated"
        />
      </b-tab>
      <b-tab v-if="showSupervisionTab" title="Información de Supervisión">
        <supervision :disabled="isReadOnly" />
      </b-tab>
      <b-tab v-if="showDispenseTab" title="Dispensas">
        <dispensations-component
          :company-id="companyId"
          :disabled="isReadOnly"
          :external-model="dispensations"
          :is-d-e-p-r="isDEPR"
          :specialist-id="specialistId"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Vue from 'vue';
import SsnSearch from './components/SsnSearch';
import UserSearch from './components/UserSearch';
import Specialist from './components/specialist-tab/Specialist';
import Supervision from './components/supervision-tab/View';
import DispensationsComponent from './components/dispensation-tab/Dispensations';

import storeMixin from '@/shared/mixins/storeGenerator';
import alert from '@/mixins/alert.mixin';
import {
  getSpecialist as _getSpecialist,
  deactivateSpecialist as _deactivateSpecialist,
  activateSpecialist as _activateSpecialist,
  getlocationservicecompany as getCompanyDetail,
  hasActiveStudentReferral as _hasActiveStudentReferral,
  getSpecialistExcemptions as _getSpecialistExcemptions,
  hasDataOnHealthDepartment as _hasDataOnHealthDepartment,
  updateLicenseFromHd as _updateLicenseFromHd,
  deleteTemporalSpecialist as _deleteTemporalSpecialist,
} from '@/modules/provider/api.js';
import { getAcademicYear as _getAcademicYear } from '@/modules/shared/academicyear.api';
import { mapGetters, mapState } from 'vuex';
import { name as userStoreName } from '@/modules/user/store';
import Departments from '@/utils/constants/departmentsId';
import roles from '@/utils/constants/roles';
import OrderedHeaderCard from 'ordered-header-card';
import CustomRadio from 'custom-radio';
import moment from 'moment';
import { getSysparameterByNames as _getSysparameterByNames } from '@/modules/shared/sysparameter.api';
import exemptionType from '@/utils/shared/constants/exemptionType';

const yesNoOptions = [
  { label: 'SI', value: 1 },
  { label: 'NO', value: 2 },
];

export default {
  name: 'ManageSpecialist',
  components: {
    SsnSearch,
    Specialist,
    Supervision,
    DispensationsComponent,
    OrderedHeaderCard,
    CustomRadio,
    UserSearch,
  },
  mixins: [storeMixin, alert],
  props: {
    specialistId: {
      type: [String, Number],
      default: () => null,
    },
  },
  data() {
    return {
      specialistData: {
        id: null,
        firstName: null,
        lastMaternalName: null,
        lastPaternalName: null,
        fullName: null,
        socialSecurityNumber: null,
        registrationNumber: null,
        companyName: null,
        isActive: null,
        locations: null,
        licenses: null,
        hasLocations: false,
        fiscalYearId: null,
        companyId: null,
        isATEvaluator: null,
        canCreateManualDispense: null,
      },
      academicyear: {},
      specialistActive: null,
      pageActions: [],
      inImmediateSaveMode: true,
      managedSpecialistId: this.specialistId == 0 ? null : this.specialistId,
      dispensations: [],
      csseOfficialOptions: yesNoOptions,
      selectedCSEEOfficialAnswer: null,
      isExemptionRequired: false,
      isExemptionParamEnabled: false,
      exemptionFiles: [],
      isDEPR: false,
      isHealthDeptNoEnabled: false,
      preSaveRequired: false,
      isNew: true,
    };
  },
  computed: {
    ...mapState('$_user', ['user']),
    canShowCSEEOfficialQuestion() {
      const companies = this.$store.state['$_user'].companies;
      if (companies.length)
        return this.userRole == roles.Provider && this.isEducationDepartment();

      return false;
    },
    isCreatingCSEEOficial() {
      return this.selectedCSEEOfficialAnswer?.value == yesNoOptions[0].value;
    },
    inEditMode() {
      return !!this.managedSpecialistId;
    },
    isReadOnly() {
      if (this.specialistData.isActive == null || this.isCreatingNewSpecialist)
        return false;

      return !this.specialistData.isActive;
    },
    canActivateOrDeactivate() {
      return this.specialistData.id != null;
    },
    isCreatingNewSpecialist() {
      const isCreating = this.$route.params.title ? false : true;
      return isCreating;
    },
    page() {
      return {
        title: this.$route.params.title || 'Especialista: Crear',
        icon: 'fas fa-user-tie',
        routes: [
          'Proveedor',
          'Especialista',
          'Especialista',
          'Crear Especialista',
        ],
      };
    },
    showSupervisionTab() {
      let specialist = this.specialistData || {};
      return (specialist.licenses || []).some((item) => item.supervisorFlag);
    },
    showDispenseTab() {
      return this.specialistData?.id && this.dispensations.length > 0;
    },
    board() {
      const cols = [
        [
          {
            label: 'Año Fiscal:',
            icon: 'fas fa-calendar-edit ',
            data: this.academicyear?.description,
            cols: this.isEducationDepartment() ? 'col-2' : undefined,
          },
          {
            label: 'Proveedor:',
            icon: 'fas fa-address-book',
            data: this.specialistData?.companyName,
          },
          {
            label: 'Especialista:',
            icon: 'fas fa-address-book',
            data:
              (this.specialistData.firstName || '') +
              ' ' +
              (this.specialistData.lastPaternalName || '') +
              ' ' +
              (this.specialistData.lastMaternalName || ''),
          },
        ],
      ];
      if (this.isEducationDepartment()) {
        cols[0].push({
          label: 'Número de KRONO:',
          icon: 'fas fa-ballot-check',
          data: (this.specialistData || {}).staffId || '-',
          cols: 'mgl-5 col-sm w-50',
        });
      }
      return cols;
    },
    companyId() {
      return (
        parseInt(this.user.profile.companyid) || this.$route.params.companyId
      );
    },
    fiscalYearId() {
      let _fiscalYearId =
        this.$route.params.fiscalYearId || this.academicyear.id;
      return parseInt(_fiscalYearId);
    },
    canDeactivateSpecialist() {
      return (
        this.userHasPermissions('provider.specialist.deactivate') &&
        this.specialistActive
      );
    },
    canActivateSpecialist() {
      return (
        this.userHasPermissions('provider.specialist.activate') &&
        !this.specialistActive
      );
    },
    canCreateDispense() {
      return (
        this.userHasPermissions('provider.dispenseManagement.create') &&
        this.specialistData?.canCreateManualDispense
      );
    },
    ...mapGetters(userStoreName, ['mainCompany']),
  },
  watch: {
    specialistActive: {
      handler() {
        this.setActionButtons();
      },
      immediate: true,
    },
  },
  async created() {
    await this.getFiscalYear();
    if (this.specialistId && this.specialistId != 0) {
      this.isNew = false;
      await Promise.all([
        this.loadInitialData(),
        this.getSpecialistExcemptions(),
      ]);
    }

    if (this.inEditMode) {
      this.setActionButtons();
      await this.getspecialistData(this.specialistId, this);
    }
    this.isDEPR = this.$route.params.isDEPR;

    _getSysparameterByNames({
      parameterNames: ['UpdatePeriodSpecialistProfileHealthDepartment'],
    }).then((sysParameters) => {
      sysParameters = sysParameters.data;
      var effectiveDate = moment(sysParameters[0].effectiveDate);
      var effectiveEndDate = moment(sysParameters[0].effectiveEndDate);

      var currentDate = moment().format('YYYY/MM/DD');

      this.isHealthDeptNoEnabled =
        moment(currentDate).isSameOrAfter(effectiveDate) &&
        moment(currentDate).isSameOrBefore(effectiveEndDate);

      if (this.inEditMode) {
        this.setActionButtons();
      }
    });
  },
  methods: {
    departments() {
      return Departments;
    },
    isEducationDepartment() {
      const companies = this.$store.state['$_user'].companies;
      return (
        Number(this.$route.params.companyId) ===
          this.departments().EducationDepartmentId ||
        companies.some((c) => c.id === this.departments().EducationDepartmentId)
      );
    },
    csseFormValidator() {
      return this.$refs['csseFormValidator'];
    },
    async getSpecialistExcemptions() {
      var self = this;
      _getSpecialistExcemptions(self.specialistId, 0, this.fiscalYearId)
        .then((response) => {
          self.dispensations = response.data;
        })
        .catch(() =>
          self.ShowToast(
            'Error',
            'Ocurrió un error cargando los datos',
            'error'
          )
        );
    },

    async loadInitialData() {
      var self = this;

      await _getSpecialist(
        this.managedSpecialistId,
        this.fiscalYearId,
        this.companyId
      )
        .then(({ data: specialistData }) => {
          self.specialistData = specialistData;
          self.specialistActive = specialistData.isActive;
        })
        .catch(() =>
          self.ShowToast(
            'Error',
            'Ocurrió un error cargando los datos',
            'error'
          )
        );
    },
    setActions(actions) {
      this.pageActions = actions;
    },

    async specialistAdded(newSpecialist) {
      await this.getFiscalYear();
      const company = await getCompanyDetail({
        fiscalYearId: this.fiscalYearId,
        companyId: this.companyId,
      });

      var specData = {
        ...newSpecialist,
        licenses: [],
        locations: [],
        companyName: company.companyName,
        fiscalYearId: this.fiscalYearId,
        companyId: this.companyId,
        id: -1,
      };
      this.inImmediateSaveMode = false;
      //ECG:Aqui trae solo un id -1 dummy en lo que llegamos a la DB
      this.managedSpecialistId = specData.id;
      this.specialistData = specData;

      this.specialistData.isCseeOfficial = this.isCreatingCSEEOficial;

      var self = this;
      Vue.nextTick(() => {
        let actions = [
          {
            text: 'Regresar',
            icon: 'far fa-arrow-circle-left',
            variant: 'outline-success',
            click: () => this.$router.push({ name: 'search-specialist' }),
          },
          {
            component: 'ActionButton',
            variant: 'success',
            text: 'Guardar',
            icon: 'fas fa-save',
            click: self.$refs.specTab.insertSpecialist,
          },
        ];

        if (this.isHealthDeptNoEnabled) {
          actions.push({
            component: 'ActionButton',
            text: 'Consultar DS',
            variant: 'outline-success',
            icon: 'fas fa-file-alt',
            click: this.consultHd,
          });
        }

        this.setActions(actions);
      });
    },
    setActionButtons() {
      let actions = [
        {
          text: 'Regresar',
          icon: 'far fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.$router.push({ name: 'search-specialist' }),
        },
        {
          component: 'ActionButton',
          text: 'Crear Dispensa',
          variant: 'outline-success',
          icon: 'fas fa-user-tie',
          click: this.createDispense,
          visible: this.canCreateDispense,
        },
        {
          component: 'ActionButton',
          text: 'Inactivar',
          variant: 'outline-success',
          icon: 'fas fa-user-slash',
          click: this.inactivateSpecialist,
          visible: this.canDeactivateSpecialist && this.canActivateOrDeactivate,
        },
        {
          component: 'ActionButton',
          text: 'Consultar DS',
          variant: 'outline-success',
          icon: 'fas fa-file-alt',
          click: this.consultHd,
          visible: this.isHealthDeptNoEnabled,
        },
        {
          component: 'ActionButton',
          text: 'Re-Activar',
          variant: 'outline-success',
          icon: 'fas fa-user',
          click: this.activateSpecialist,
          visible: this.canActivateSpecialist && this.canActivateOrDeactivate,
        },
      ];
      this.setActions(actions);
    },
    async consultHd() {
      if (!this.specialistData.registrationNumber) {
        this.ShowToast(
          'Error',
          'El especialista no tiene un número de registro de salud',
          'error'
        );
        return;
      }

      if (this.managedSpecialistId === -1) {
        this.preSaveRequired = true;
        await this.$refs.specTab.insertSpecialist(false);
        return;
      }

      await _hasDataOnHealthDepartment(
        this.managedSpecialistId,
        this.specialistData.registrationNumber
      )
        .then(async ({ data }) => {
          if (!data) {
            this.ShowToast(
              'Error',
              'El Número de Registro de Salud no es válido o no se encuentra registrado en el Departamento de Salud.',
              'error'
            );
            return;
          }

          if (this.preSaveRequired) {
            this.preSaveRequired = false;

            this.updateLicenseFromHd(true);

            return;
          }

          const answer = await this.ShowCancelModal(
            'Confirmación',
            `¿Se encontraron licencias registradas en el Departamento de salud desea agregarlas al perfil?`,
            'Sí',
            'No'
          );
          if (answer) {
            this.updateLicenseFromHd();
          }
        })
        .catch((error) => {
          this.ShowToast('', error.response.data.message, 'error');
        });
    },
    async updateLicenseFromHd(changeRoute = false) {
      await _updateLicenseFromHd(this.specialistData.registrationNumber)
        .then(() => {
          if (changeRoute) {
            this.goToSpecialist(this.specialistData);
          }

          this.loadInitialData();
        })
        .catch(() => {
          this.ShowToast(
            'Error',
            'Ocurrió un error cargando los datos',
            'error'
          );
        });
    },
    async inactivateSpecialist() {
      const specialistModel = {
        specialistId: parseInt(this.managedSpecialistId),
        companyId: this.companyId,
        fiscalYearId: this.fiscalYearId,
      };
      _hasActiveStudentReferral(specialistModel)
        .then(async ({ data: hasActiveStudent }) => {
          if (!hasActiveStudent) {
            const answer = await this.ShowCancelModal(
              'Confirmación',
              `¿Está seguro que desea inactivar a el(la) Especialista ${this.specialistData.fullName}?`,
              'Sí',
              'No'
            );
            if (answer) {
              await _deactivateSpecialist(specialistModel);
              this.ShowToast(
                '',
                'Especialista inactivado exitosamente',
                'success'
              );

              this.loadInitialData();
            }
          }
        })
        .catch(({ response: error }) => {
          const errorMessage = error.data.message;
          this.ShowToast('Alerta', errorMessage, 'error');
          if (errorMessage.indexOf('(0196)') !== -1) {
            this.$router.push({
              name: 'change-specialist',
              params: {
                specialistId: this.specialistId,
                companyId: specialistModel.companyId,
              },
            });
          }
        });
    },

    async activateSpecialist() {
      const specialistModel = {
        specialistId: parseInt(this.managedSpecialistId),
        companyId: this.companyId,
        fiscalYearId: this.fiscalYearId,
      };

      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea re-activar el(la) Especialista ${this.specialistData.fullName}?`,
        'Sí',
        'No'
      );
      if (answer) {
        await _activateSpecialist(specialistModel);
        this.ShowToast('', 'Especialista reactivado exitosamente', 'success');

        this.loadInitialData();
      }
    },

    specialistCreated(specialistData) {
      //MMR: Se necesita para identificar que se encontro un especialista.
      this.specialistId = parseInt(specialistData.id);

      //ECG:Aqui persistimos el id real generado en la DB
      this.managedSpecialistId = specialistData.id;
      this.specialistActive = specialistData.isActive;
      this.inImmediateSaveMode = true;
      this.setActionButtons();

      if (this.preSaveRequired) {
        this.consultHd();
      } else {
        this.goToSpecialist(specialistData);
      }
    },
    goToSpecialist(specialistData) {
      this.$router.push({
        name: 'specialist-management',
        params: {
          title: 'Especialista: Editar',
          specialistId: specialistData.id,
          companyId: this.companyId,
          fiscalYearId: this.fiscalYearId,
          isActive: specialistData.isActive,
          isDEPR:
            specialistData.moreThanOneCompany &&
            specialistData.hasExcemptionApproved,
        },
      });
    },

    specialistChange(specialistData) {
      this.specialistData = specialistData;
    },

    specialistFound(searchResult) {
      this.exemptionFiles = searchResult.exemptionFiles;
      this.isExemptionRequired = searchResult.isExemptionRequired;
      this.isExemptionParamEnabled = searchResult.isExemptionParamEnabled;
      // MMR: Se comenta para darle pie al caso de uso donde el especialista no pertenece
      // a la compania. Revisar por ECG
      //if (searchResult.isRelatedToOwnCompany) {
      this.getspecialistData(searchResult.id, this);

      //MMR: Se necesita para identificar que se encontro un especialista.
      //A.L: this.specialistId = searchResult.id this was causing a mutation  prop directly

      this.managedSpecialistId = searchResult.id;
      this.setActionButtons();
      //}
    },

    async getspecialistData(specialistId, self) {
      await _getSpecialist(specialistId, this.fiscalYearId, this.companyId)
        .then(({ data }) => {
          self.specialistData = data;
          this.setActionButtons();
        })
        .catch(() =>
          self.ShowToast(
            'Error',
            'Ocurrió un error cargando los datos',
            'error'
          )
        );
    },

    async getFiscalYear() {
      let self = this;
      const res = await _getAcademicYear(self.fiscalYearId).catch(() => {
        self.ShowToast('Error', 'Ocurrió un error cargando los datos', 'error');
      });

      this.academicyear = res.data;
      return res.data;
    },
    onChangeCSSEEOfficialAnswer(value) {
      this.selectedCSEEOfficialAnswer = value;
    },
    createDispense() {
      this.$router.push({
        name: 'dispensation-request',
        params: {
          specialistId: this.specialistId,
          companyId: this.companyId,
          academicYearId: this.fiscalYearId,
          exemptionType: exemptionType.EspecialistaDEPR,
          specialistSupervisions: [],
        },
      });
    },
  },
  async beforeRouteLeave(_, from, next) {
    if (
      this.isNew &&
      this.managedSpecialistId &&
      this.managedSpecialistId > 0 &&
      (!this.specialistData.locations ||
        this.specialistData.locations.length === 0)
    ) {
      const discardText = `<span class="text-danger"> al salir la información se perderá</span>`;
      const { value: confirmed, dismiss } = await this.ShowCancelModalClosable(
        'Confirmación',
        `Usted cuenta con información sin documentar, ${discardText} ¿desea continuar con la documentación? `,
        `Continuar`,
        'Salir',
        true
      );
      const cancelled = ['close', 'backdrop'].includes(dismiss);
      if (cancelled || confirmed) return false; //keep in the screen if don't want to save but stay

      await _deleteTemporalSpecialist(this.managedSpecialistId);
    }
    next();
  },
};
</script>

<style lang="scss" scoped>
.manage-specialist ::v-deep {
  .manage-specialist__custom-radio {
    .radio-button {
      background-color: #f2f2f2;
      margin-left: 8px;
    }

    .custom-radio-container {
      .bg-checked {
        background-color: #2db782 !important;
        color: white;

        .cr {
          border: 2px solid white;

          i {
            font-size: 0.653rem;
            color: white;
          }
        }
      }

      .error {
        border-color: #c9545e !important;
      }
    }
  }
}
</style>
